import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../../Styles/Player.css';
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';

function PlayerPerformance() {
  const params = useParams();
  const player = params["player"];

  const scoresArray = [];
  const inplayArray = [];
  const [L5score, setL5Score] = useState(0);
  const [L15Score, setL15Score] = useState(0);
  const [data, setData] = useState([]);
  const [DataPlayer, setDataPlayer] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [openItem, setOpenItem] = useState(null);

  const handleToggle = (itemId) => {
    setOpenItem(openItem === itemId ? null : itemId);
  };

  const getBackgroundColor = (zahl) => {
    if (zahl === 0) {
      return 'red';
    } else if (zahl >= 75) {
      return 'darkgreen';
    } else {
      // Linear interpolation for color between red and green
      const orangeAnteil = (zahl / 75) * 255;
      return `rgb(${255 - orangeAnteil}, ${orangeAnteil}, 0)`;
    }
  };

  /* Points for StocksFC */
  const ShotPoints = 1;
  const ShotOnTargetPoints = 4;
  const GoalPoints = 20;
  const AssistPoints = 12;
  const KeyPassPoints = 5;
  const InterceptionPoints = 2;
  const HitWoodworkPoints = 4;
  const PenaltyWonPoints = 10;
  const TacklePoints = 3;
  const BlockPoints = 2;
  const SuccessfulDribblePoints = 3;
  const SavePoints = 7;
  const PenaltySavedPoints = 20;
  const GoalConcededPoints = -4;
  const OwnGoalPoints = -20;
  const YellowCardPoints = -4;
  const RedCardPoints = -20;
  const PenaltyMissedPoints = -7;
  const PenaltyConcededPoints = -10;
  const DispossessedPoints = -1;
  const WinningTeamPoints = 20;
  const CleanSheetPoints = 20;

  function getStatValue(statsArray, statName) {
    const statObject = statsArray?.find(item => item.stat === statName);
    return statObject ? statObject.statValue : 0;
  }

  function formatGameDateTime(inputDateTime) {
    const originalDateTime = new Date(inputDateTime);
    const day = originalDateTime.getDate().toString().padStart(2, '0');
    const month = (originalDateTime.getMonth() + 1).toString().padStart(2, '0');
    const year = originalDateTime.getFullYear();
    const hours = originalDateTime.getHours().toString().padStart(2, '0');
    const minutes = originalDateTime.getMinutes().toString().padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}`;
  }

  const calculateTotalPoints = (comp) => {
    if((comp.gameStarted == 1 && comp.fieldStatus == "ON_FIELD") ||
       (comp.gameStarted != 1 && comp.fieldStatus == "ON_FIELD") ||
       (comp.gameStarted == 1 && comp.fieldStatus == "SUBSTITUTED") ||
       (comp.gameStarted != 1 && comp.fieldStatus == "SUBSTITUTED")){       
          const score = 
            (comp.totalScoringAtt - comp.ontargetScoringAtt) * ShotPoints + 
            comp.ontargetScoringAtt * ShotOnTargetPoints +
            comp.goals * GoalPoints +
            comp.goalAssist * AssistPoints +
            getStatValue(comp.so5Score.detailedScore, "adjusted_total_att_assist") * KeyPassPoints +
            comp.interceptionWon * InterceptionPoints +
            getStatValue(comp.so5Score.detailedScore, "assist_penalty_won") * PenaltyWonPoints + 
            comp.wonTackle * TacklePoints +
            getStatValue(comp.so5Score.detailedScore, "outfielder_block") * BlockPoints + 
            getStatValue(comp.so5Score.detailedScore, "won_contest") * SuccessfulDribblePoints +
            getStatValue(comp.so5Score.detailedScore, "saves") * SavePoints +
            comp.penaltiesSaved * PenaltySavedPoints +
            (DataPlayer.position == "Goalkeeper" ||  DataPlayer.position == "Defender" ? comp.goalsConceded * GoalConcededPoints : 0) +
            comp.ownGoals * OwnGoalPoints +
            comp.yellowCard * YellowCardPoints +
            comp.redCard * RedCardPoints + 
            comp.penaltyKickMissed * PenaltyMissedPoints +
            getStatValue(comp.so5Score.detailedScore, "penalty_conceded") * PenaltyConcededPoints +
            (comp.game.winner && comp.game.winner.name === DataPlayer.activeClub?.name ? WinningTeamPoints : 0) +
            (comp.game.winner && comp.game.winner.name === DataPlayer.activeNationalTeam?.name ? WinningTeamPoints : 0) + 
            (comp.cleanSheet != 0 && (DataPlayer.position == "Goalkeeper" ||  DataPlayer.position == "Defender") ? CleanSheetPoints : 0);
        return score;
      }
      else {
        return 0;
      }
  };

  const calculateInplayPoints = (comp) => {
    if((comp.gameStarted == 1 && comp.fieldStatus == "ON_FIELD") ||
       (comp.gameStarted != 1 && comp.fieldStatus == "ON_FIELD") ||
       (comp.gameStarted == 1 && comp.fieldStatus == "SUBSTITUTED") ||
       (comp.gameStarted != 1 && comp.fieldStatus == "SUBSTITUTED")){       
          const score = 
            (comp.goals  +
            comp.goalAssist +
            getStatValue(comp.so5Score.detailedScore, "adjusted_total_att_assist"));
        return score;
      }
      else {
        return 0;
      }
  };

  function calculateAverages(scores, length) {
    const relevantScores = scores.slice(0, length);
    const average = relevantScores.length > 0 ? relevantScores.reduce((sum, number) => sum + number, 0) / relevantScores.length : 0;
    return average;
  }

  useEffect(() => {
    const fetchData = async () => {
      await fetch(`https://vercel-express-blue.vercel.app/api/v1/player/performanceStats/${player}`).then(
        res => res.json()
      ).then(
        data => {
          setDataPlayer(data.player.football.player);
          setData(data.player.football.player.gameStats);
          setLoaded(true);
        }
      )
    }
    fetchData();
  }, []);      

  useEffect(() => {
    if (loaded && DataPlayer) {
      setL5Score(calculateAverages(scoresArray, 5));
      setL15Score(calculateAverages(scoresArray, 15));
    }
  }, [loaded, DataPlayer, data]);
    
  // Stat item with name and value/points display
  const StatItem = ({ name, value, points, color }) => {
    if (!value && value !== 0) return null;
    
    return (
      <div className="stat-row">
        <div className="stat-name">{name}:</div>
        <div className="stat-value">
          {value} {points !== undefined && points !== 0 && (`(${points > 0 ? '+' : ''}${points})`)}
        </div>
      </div>
    );
  };

  const renderPlayer = () => {     
    return data.map((comp, index) => {
      const totalPoints = calculateTotalPoints(comp);
      scoresArray.push(totalPoints);

      const inplay = calculateInplayPoints(comp);
      inplayArray.push(inplay);

      // Calculate individual stats for cleaner rendering
      const shotsOffTarget = comp.totalScoringAtt - comp.ontargetScoringAtt || 0;
      const shotsOnTarget = comp.ontargetScoringAtt || 0;
      const goals = comp.goals || 0;
      const assists = comp.goalAssist || 0;
      const keyPasses = getStatValue(comp.so5Score.detailedScore, "adjusted_total_att_assist");
      const interceptions = comp.interceptionWon || 0;
      const penaltiesWon = getStatValue(comp.so5Score.detailedScore, "assist_penalty_won");
      const tackles = comp.wonTackle || 0;
      const blocks = getStatValue(comp.so5Score.detailedScore, "outfielder_block");
      const dribbles = getStatValue(comp.so5Score.detailedScore, "won_contest");
      const saves = getStatValue(comp.so5Score.detailedScore, "saves");
      const penaltiesSaved = comp.penaltiesSaved || 0;
      const goalsConceded = comp.goalsConceded || 0;
      const ownGoals = comp.ownGoals || 0;
      const yellowCards = comp.yellowCard || 0;
      const redCards = comp.redCard || 0;
      const penaltiesMissed = comp.penaltyKickMissed || 0;
      const penaltiesConceded = getStatValue(comp.so5Score.detailedScore, "penalty_conceded");
      
      // Winning team calculation
      const isWinningTeam = comp.game.winner && (
        comp.game.winner.name === DataPlayer.activeClub?.name || 
        comp.game.winner.name === DataPlayer.activeNationalTeam?.name
      );
      
      // Clean sheet calculation
      const hasCleanSheet = comp.cleanSheet !== 0 && (
        DataPlayer.position === "Goalkeeper" || 
        DataPlayer.position === "Defender"
      );

      return (
        <div className="col-sm-10 mb-3 player_general_card" key={index}>
          <div className="card round_corners">
            <div className="card-body">
              <div className="match-info">
                <div>
                  <h5 className="card-title">
                    {comp.game.homeTeam.name} {comp.game.homeGoals} - {comp.game.awayGoals} {comp.game.awayTeam.name}
                  </h5>
                  <p className="match-competition">{comp.game.competition.name}</p>
                  <p className="match-date">{formatGameDateTime(comp.game.date)}</p>
                </div>
                <div>
                <span className={`player-status ${comp.gameStarted == 1 ? 'status-started' : 'status-not-started'}`}>
                  {comp.gameStarted == 1 ? 'Started' : 'Not started'}
                </span>
                </div>
              </div>
  
              <hr />
              
              {/* New layout: Stats overview with button on right */}
              <div className="stats-overview">
                <div className="stat-row">
                  <div className="stat-label">
                    <strong>Points:</strong>
                  </div>
                  <div className="stat-value">
                    <span 
                      className="performancePoints" 
                      style={{backgroundColor: getBackgroundColor(totalPoints)}}
                    >
                      {Math.round(totalPoints)}
                    </span>
                  </div>
                  <div className="details-button">
                    <button 
                      className="btn btn-sm toggle-button" 
                      onClick={() => handleToggle(index)} 
                      aria-controls={`collapse-${index}`} 
                      aria-expanded={openItem === index}
                    >
                      {openItem === index ? 'Hide details' : 'See details'}
                    </button>
                  </div>
                </div>
  
                <div className="stat-row">
                  <div className="stat-label">
                    <strong>Inplay points:</strong>
                  </div>
                  <div className="stat-value">
                    <span className="inplay-points">{inplay}</span>
                  </div>
                  <div className="details-button">
                    {/* Empty div to maintain the grid layout */}
                  </div>
                </div>
              </div>
            
              {/* Detailed stats section */}
              <Collapse in={openItem === index}>
                <div id={`collapse-${index}`} className="details-section">
                  <h6>Positive Actions</h6>
                  <div className="stats-column">
                    <StatItem name="Shots off target" value={shotsOffTarget} points={shotsOffTarget * ShotPoints} />
                    <StatItem name="Shots on target" value={shotsOnTarget} points={shotsOnTarget * ShotOnTargetPoints} />
                    <StatItem name="Goals" value={goals} points={goals * GoalPoints} />
                    <StatItem name="Assists" value={assists} points={assists * AssistPoints} />
                    <StatItem name="Key passes" value={keyPasses} points={keyPasses * KeyPassPoints} />
                    <StatItem name="Interceptions" value={interceptions} points={interceptions * InterceptionPoints} />
                    <StatItem name="Penalties won" value={penaltiesWon} points={penaltiesWon * PenaltyWonPoints} />
                    <StatItem name="Tackles won" value={tackles} points={tackles * TacklePoints} />
                    <StatItem name="Blocks" value={blocks} points={blocks * BlockPoints} />
                    <StatItem name="Successful dribbles" value={dribbles} points={dribbles * SuccessfulDribblePoints} />
                    <StatItem name="Saves" value={saves} points={saves * SavePoints} />
                    <StatItem name="Penalties saved" value={penaltiesSaved} points={penaltiesSaved * PenaltySavedPoints} />
                    <StatItem name="Winning team" value={isWinningTeam ? "Yes" : "No"} points={isWinningTeam ? WinningTeamPoints : 0} />
                    <StatItem name="Clean sheet" value={hasCleanSheet ? "Yes" : "No"} points={hasCleanSheet ? CleanSheetPoints : 0} />
                  </div>
                  
                  <h6 className="mt-3">Negative Actions</h6>
                  <div className="stats-column">
                    {(DataPlayer.position === "Goalkeeper" || DataPlayer.position === "Defender") && (
                      <StatItem name="Goals conceded" value={goalsConceded} points={goalsConceded * GoalConcededPoints} />
                    )}
                    <StatItem name="Own goals" value={ownGoals} points={ownGoals * OwnGoalPoints} />
                    <StatItem name="Yellow cards" value={yellowCards} points={yellowCards * YellowCardPoints} />
                    <StatItem name="Red cards" value={redCards} points={redCards * RedCardPoints} />
                    <StatItem name="Penalties missed" value={penaltiesMissed} points={penaltiesMissed * PenaltyMissedPoints} />
                    <StatItem name="Penalties conceded" value={penaltiesConceded} points={penaltiesConceded * PenaltyConcededPoints} />
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      );
    });
  };
    
  return (
    <div className="player_general">           
      {loaded ? (
        <>
          <h1 className="main-headline">Player Performance</h1> 

          <div className="col-sm-10 mb-4 player_general_card">
            <div className="card round_corners">
              <div className="card-body">
                <h5 className="card-title">Average Scores</h5>
                <div className="average-scores">
                  <div className="average-item">
                    <span><strong>Last 5 games:</strong></span>
                    <span 
                      className="performancePoints" 
                      style={{backgroundColor: getBackgroundColor(L5score)}}
                    >
                      {Math.floor(L5score)}
                    </span>
                  </div>
                  <div className="average-item">
                    <span><strong>Last 15 games:</strong></span>
                    <span 
                      className="performancePoints" 
                      style={{backgroundColor: getBackgroundColor(L15Score)}}
                    >
                      {Math.floor(L15Score)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {renderPlayer()}
        </>
      ) : (
        <div className="text-center mt-5">
          <p>Loading player data...</p>
        </div>
      )}    
    </div>
  );
}

export default PlayerPerformance;
